// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

// export const environment = {
//   production: false,
//   firebase: {
//     apiKey: 'AIzaSyDmxV96ZQCAhHt8LMAvlvXuOL1VL3Vmz4o',
//     authDomain: 'thinslabz-500634536555.firebaseapp.com',
//     databaseURL: 'thinslabz-500634536555.firebaseapp.com',
//     projectId: 'thinslabz',
//     storageBucket: 'gs://thinslabz-500634536555.appspot.com/'
//     }
// };

// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false
};



// WEBPACK FOOTER //
// /tmp/build_0264da94/src/environments/environment.ts